// extracted by mini-css-extract-plugin
module.exports = {"section":"FaqAndCTA_section__mXAVH","wrap":"FaqAndCTA_wrap__2x01i","column":"FaqAndCTA_column__3k9zh"};